import { __rest } from 'tslib';
import React from 'react';
import Link from 'next/link';
import { styled } from '@teko/ui';

const Anchor = styled.a `
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
    var { targetPath, children, targetType = '_self', passHref = false } = _a, props = __rest(_a, ["targetPath", "children", "targetType", "passHref"]);
    if (!targetPath)
        return React.createElement(React.Fragment, null, children);
    const a11yProps = {};
    if (typeof children !== 'string') {
        a11yProps['aria-label'] = 'Image';
    }
    if (targetPath.startsWith('http') || targetPath.startsWith('/'))
        return (React.createElement(Anchor, Object.assign({ target: targetType, href: targetPath }, a11yProps, props), children));
    return (React.createElement(Link, { href: passHref ? targetPath : `/search?${targetPath}` },
        React.createElement(Anchor, Object.assign({ target: targetType, href: passHref ? targetPath : `/search?${targetPath}` }, a11yProps, props), children)));
};

export { CustomLink as C };
